import { lazy } from 'react';
import type { PageRouter } from '@tools/ui/types';

const InboxTable = lazy(
  () =>
    import(/* webpackChunkName: "SherlockRoutes" */ '../risk-inbox/inbox.table')
);

const PersonalPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../risk-inbox/personal-inbox/personalPage'
    )
);

const SherlockGenericInboxTable = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../genericInbox/sherlockTable'
    )
);

export const personalRoutes: PageRouter[] = [
  {
    name: 'payments',
    path: '/payments',
    component: PersonalPage,
    exact: false,
    tabs: [
      {
        name: 'live',
        path: '/live',
        component: InboxTable,
        exact: false
      },
      {
        name: 'pending',
        path: '/pending',
        component: InboxTable,
        exact: true
      },
      {
        name: 'escalated',
        path: '/escalated',
        component: InboxTable,
        exact: true
      },
      {
        name: 'archive',
        path: '/archive',
        component: InboxTable,
        exact: true
      }
    ]
  },
  {
    name: 'organizations',
    path: '/organizations',
    component: PersonalPage,
    exact: false,
    tabs: [
      {
        name: 'tasks',
        path: '/tasks',
        component: SherlockGenericInboxTable,
        exact: true
      },
      {
        name: 'archive',
        path: '/archive',
        component: SherlockGenericInboxTable,
        exact: true
      }
    ]
  }
];
